import { render, staticRenderFns } from "./SiniestroNegocio.vue?vue&type=template&id=18a69e10&scoped=true&"
import script from "./SiniestroNegocio.vue?vue&type=script&lang=js&"
export * from "./SiniestroNegocio.vue?vue&type=script&lang=js&"
import style0 from "./SiniestroNegocio.vue?vue&type=style&index=0&id=18a69e10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a69e10",
  null
  
)

export default component.exports